import mixins from 'vue-typed-mixins'
import globalMixin from '../globalMixin'
import routeMixin from '@/router/routeMixin'
import mobileTypeMixin from '@/global/mobile/mobileTypeMixin'

export default mixins(routeMixin, globalMixin, mobileTypeMixin).extend({
})
